<div class="busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *fesListView="let filteredPaths of paths">
        <table class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="stage">Stage</th>
                    <th fesSortField="buildingId">Building</th>
                    <th fesSortField="buildingName">Name</th>
                    <th fesSortField="pathId">Path</th>
                    <th fesSortField="floor">Floor</th>
                    <th fesSortField="cycle" [sortType]="'numeric'">Cycle</th>        
                    <th fesSortField="status.approved.timestamp" [valueResolver]="monthDayResolver">Scout Completed</th>
                    <th fesSortField="status.scheduleRequested.timestamp" [valueResolver]="monthDayResolver">Test Requested</th>
                    <th fesSortField="schedule.scheduledDate" [valueResolver]="monthDayResolver">Test</th>
                    <th fesSortField="scheduler">Scheduler</th>
                    <th fesSortField="tester">Tester</th>
                    <th style="text-align: center">
                        <button class="new-test-btn btn btn-secondary" (click)="newPathTest()">
                            <i class="fa fa-plus-square"></i> new
                        </button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <app-filter-field-config>
                            <input fesFilterField="stage" [value]="activeStage" [mode]="activeStage?'=':'contains'" class="small w-100" />
                        </app-filter-field-config>
                    </td>
                    <td>
                        <input fesFilterField="buildingId" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="buildingName" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="pathId" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="floor" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="cycle" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="status.approved.timestamp" [valueResolver]="monthDayResolver" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="status.scheduleRequested.timestamp" [valueResolver]="monthDayResolver" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="schedule.scheduledDate" [valueResolver]="monthDayResolver" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="scheduler" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="tester" class="small w-100" />
                    </td>
                    <td></td>
                </tr>
                <tr *ngFor="let path of filteredPaths">
                    <td>{{path.stage}}</td>
                    <td>{{path.buildingId}}</td>
                    <td>{{path.buildingName}}</td>
                    <td>{{path.pathId}}</td>
                    <td>{{path.floor}}</td>
                    <td>{{path.cycle}}</td>
                    <td>{{path.status?.approved.timestamp|date:'MM/dd'}}</td> <!--Get this from scout status -->
                    <td>{{path.status?.scheduleRequested.timestamp|date:'MM/dd'}}</td>
                    <td>{{path.schedule?.scheduledDate|date:'MM/dd'}}</td>
                    <td>{{path.scheduler}}</td>
                    <td>{{path.tester}}</td>
                    <td class="text-center align-middle text-nowrap">
                        <div class="flex flex-row">
                            <a class="mr-1" [routerLink]="" href="javascript:false;" (click)="editPathTest(path)">edit</a>
                            <div class="btn-group p-0 m-0" dropdown>
                              <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-edit-options">
                                <span class="caret"></span>
                              </a>
                              <ul style="z-index:9999999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="edit-options-btn">
                                <li role="menuitem"><button class="btn btn-danger" (click)="deletePathTest(path)">Delete</button></li>
                              </ul>
                            </div>
                          </div>
                    </td>
                </tr>
            </tbody>

        </table>
    </div>
</div>